import { RouteLocationNormalized } from 'vue-router';
import useGuardRouteResolver from '../composable/router/use-guard-route-resolver';

export default async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  const { resolve } = useGuardRouteResolver();

  const errorOccured = await resolve(to, from);

  return !errorOccured;
};
